import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ApiAccessToken, AppsService } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-delete-apiaccess-token',
  template: `
    <h2 class="nomargin">Enter your password</h2>
    <p>Enter your password to delete this access token ({{ dialogData.token.name }}).</p>
    <div class="dialog-content" style="margin-top: 24px">
      <!-- Honeypot to prevent 1Password changing token names, it did not respect autocomplete -->
      <input style="position: absolute; top: -9999px;" type="email" />

      <mat-form-field class="fw">
        <input matInput [(ngModel)]="password" placeholder="Password" type="password" (keyup.enter)="deleteToken()" />
        <mat-hint *ngIf="error" class="raspberry-darker">{{ error }}</mat-hint>
      </mat-form-field>
    </div>

    <div fxLayoutAlign="end center" fxLayoutGap="8px">
      <sbnb-button type="secondary" (click)="dialogRef.close()">Cancel</sbnb-button>
      <sbnb-button type="primary" [loading]="deleting" (click)="deleteToken()">Delete</sbnb-button>
    </div>
  `,
})
export class DialogDeleteAPIAccessTokenComponent {
  password: string = '';
  error: string = '';
  deleting: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteAPIAccessTokenComponent>,
    private appsService: AppsService,
    @Inject(MAT_DIALOG_DATA) public dialogData: { token: ApiAccessToken }
  ) { }

  deleteToken() {
    this.deleting = true;
    this.appsService.deleteAPIAccessToken(this.dialogData.token.id, this.password).subscribe(
      (res) => {
        this.dialogRef.close(true);
      },
      (err) => {
        this.deleting = false;
        this.error = err.error.message;
      }
    );
  }
}
